/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Type/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Type({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPayments/Content/Content/MaximumPaymentPlanLength/Type"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let settingsDataMaximumPaymentPlanLengthTypeValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.maximum_payment_plan_length.type',
})
let constantData = 'TOTAL'
let aggregateData = fromAggregate.equals(settingsDataMaximumPaymentPlanLengthTypeValueData, constantData)
let onClick = fromHelpers.useOnClickTotal({
  children,
  viewPath
  
})
let settingsDataMaximumPaymentPlanLengthTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.maximum_payment_plan_length.type',
})
let constantData1 = 'RELATIVE'
let aggregateData1 = fromAggregate.equals(settingsDataMaximumPaymentPlanLengthTypeValueData1, constantData1)
let onClick1 = fromHelpers.useOnClickRelative({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Type.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-bxIu': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick}
 data="settings.data.maximum_payment_plan_length.type"
 data="'TOTAL'"
 aggregate="/Data/aggregate equals"
 isSelected={aggregateData}
 text="Total"
/>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick1}
 data="settings.data.maximum_payment_plan_length.type"
 data="'RELATIVE'"
 aggregate="/Data/aggregate equals"
 isSelected={aggregateData1}
 text="Relative"
/>
</div>
{children}
</React.Fragment>)
}